
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppWarning } from '@/components'

@Component({
    components: {
        AppWarning,
    },
})
export default class CommonAppWarning extends Vue {
    @Prop() private app!: AppEntity

    get showAppWarning() {
        return this.app.warningLevel > 0
    }

    get warningType() {
        if (this.app.warningLevel >= 2) {
            return 'error'
        } else {
            return 'warning'
        }
    }

    get warningText() {
        if (this.app.warningLevel === 3) {
            return 'Esta loja vende itens relacionados a fumo que serão bloqueados no app Android. Por também vender bebidas, terá uma restrição de idade de +18 nos apps'
        } else if (this.app.warningLevel === 2) {
            return 'Esta loja vende itens relacionados a fumo que serão bloqueados no app Android'
        } else {
            return 'Esta loja vende bebidas alcoólicas e terá uma restrição de idade de +18 nos apps'
        }
    }
}
